import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { listsTabsContainer } from "../../styles/frequentListStyles";

export const FrequentListTabs = ({ lists, activeListId, onTabChange }) => {
  const hasValidActiveId = lists?.some((list) => list.id === activeListId);

  return (
    <Box sx={listsTabsContainer}>
      {hasValidActiveId && (
        <Tabs value={activeListId} onChange={onTabChange} variant="scrollable" scrollButtons="auto" aria-label="frequent lists tabs">
          {lists.map((list) => (
            <Tab key={list.id} value={list.id} label={list.name} />
          ))}
        </Tabs>
      )}
    </Box>
  );
};
